exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#monthToast .table .tb-tr td {\n  padding: 0.3rem 0;\n}", ""]);

// exports
